/* 
 * 接口统一集成模块
 */
//api数据
import * as login from './api/login'
import * as bananer from './api/bananer'
import * as userManage from './api/user'
import * as module from './api/module'
import * as upload from './api/upload'
import * as questionBank from './api/questionBank'
import * as price from './api/price'
import * as video from './api/video'
import * as examCenter from './api/examCenter'
import * as xieyi from './api/xieyi'
import * as introduce from './api/introduce'
// mokc数据
import * as user from './moudules/user'
import * as dept from './moudules/dept'
import * as role from './moudules/role'
import * as menu from './moudules/menu'
import * as dict from './moudules/dict'
import * as log from './moudules/log'


// 默认全部导出
export default {
    login,
    bananer,
    userManage,
    module,
    upload,
    questionBank,
    price,
    video,
    examCenter,
    xieyi,
    introduce,

    user,
    dept,
    role,
    menu,
    dict,
    log
}


// WEBPACK FOOTER //
// ./src/http/api.js